module.exports = __webpack_public_path__ + "img/football.33341383.svg";